"use strict";

exports.__esModule = true;
exports.getCtrlKeysByPlatform = exports.getActiveModMap = void 0;

var _collections = require("../utils/collections");

var _codes = require("./codes");

/* istanbul ignore next */
const getCtrlKeysByPlatform = () => {
  return {
    CtrlCmd: (0, _collections.isMac)() ? 'metaKey' : 'ctrlKey',
    WinCtrl: (0, _collections.isMac)() ? 'ctrlKey' : 'metaKey'
  };
};

exports.getCtrlKeysByPlatform = getCtrlKeysByPlatform;

const getActiveModMap = bindings => {
  const modBindings = bindings.filter(item => !!_codes.KeyMod[item]);
  const activeModMap = {
    CtrlCmd: false,
    Shift: false,
    Alt: false,
    WinCtrl: false
  };
  modBindings.forEach(code => {
    const modKey = _codes.KeyMod[code];
    activeModMap[modKey] = true;
  });
  return activeModMap;
};

exports.getActiveModMap = getActiveModMap;